import React, { useState, useId } from "react";
import "./HoverTooltip.scss";

/**
 * Dark tooltip (black panel, white text) shown on hover over the trigger area.
 */
const HoverTooltip = ({ content, children, placement = "top" }) => {
  const genId = useId();
  const tooltipId = `hover-tt-${genId.replace(/:/g, "")}`;
  const [open, setOpen] = useState(false);
  const text = content != null ? String(content).trim() : "";

  if (!text) {
    return children;
  }

  return (
    <span
      className="hover-tooltip-wrapper"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {children}
      {open ? (
        <span
          id={tooltipId}
          className={`hover-tooltip-panel hover-tooltip-panel--${placement === "bottom" ? "bottom" : "top"}`}
          role="tooltip"
        >
          <span className="hover-tooltip-panel__arrow" aria-hidden />
          {text}
        </span>
      ) : null}
    </span>
  );
};

export default React.memo(HoverTooltip);
